import React from 'react';
import ArchiX6 from '@components/archiX6';
import type {ArchiX6Props} from '@/types/components/archiX6.types';
import type {CatalogChangeDto, DiagramVersionNavigatePayload, ModelPatchDto} from '@/types/api';

const DiagramEditorX6 = React.forwardRef<
	{
		save?: () => Promise<void>;
		applyRemotePatch?: (patch: ModelPatchDto) => void;
		applyVersionNavigate?: (payload: DiagramVersionNavigatePayload) => void;
		applyCatalogChange?: (changes: CatalogChangeDto[]) => void;
	},
	ArchiX6Props
>(
	(
		{
			initialXml,
			initialJson,
			initialDiagramName,
			initialViewId,
			onViewChange,
			onSave,
			onApplyPatch,
			onInfoClick,
			onClose,
			assistantSlot,
			diagramCollaboration,
			catalog,
			readOnly,
			remoteCursors,
			objectLocks,
			clientSessionId,
			onCursorSend,
			onLiveSend,
			onLockSend,
		},
		ref
	) => {
		return (
			<div style={{width: '100%', height: '100%', position: 'relative'}}>
				<ArchiX6
					ref={ref}
					initialXml={initialXml}
					initialJson={initialJson}
					initialDiagramName={initialDiagramName}
					initialViewId={initialViewId}
					onViewChange={onViewChange}
					onSave={onSave}
					onApplyPatch={onApplyPatch}
					onInfoClick={onInfoClick}
					onClose={onClose}
					assistantSlot={assistantSlot}
					diagramCollaboration={diagramCollaboration}
					catalog={catalog}
					readOnly={readOnly}
					remoteCursors={remoteCursors}
					objectLocks={objectLocks}
					clientSessionId={clientSessionId}
					onCursorSend={onCursorSend}
					onLiveSend={onLiveSend}
					onLockSend={onLockSend}
				/>
			</div>
		);
	}
);

DiagramEditorX6.displayName = 'DiagramEditorX6';

export default DiagramEditorX6;
